import { Shield, ShieldOff, Lock } from 'lucide-react';

interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
}

export function WelcomeScreen({ onEnable, onSkip }: WelcomeScreenProps): JSX.Element {
  return (
    <div className="applock-screen" data-testid="applock-welcome">
      <div className="applock-card">
        <div className="applock-icon-wrap">
          <Shield size={36} strokeWidth={2} />
        </div>
        <h1 className="applock-title">Protect Patient Data</h1>
        <p className="applock-description">
          This calculator stores dosing sessions locally on this device.
          Enable app lock to encrypt patient data with a password using
          AES-256-GCM encryption. Without the password, stored data is
          unreadable.
        </p>
        <div className="applock-actions">
          <button
            type="button"
            className="applock-btn applock-btn-primary"
            onClick={onEnable}
          >
            <Shield size={20} strokeWidth={2} />
            Enable App Lock
          </button>
          <button
            type="button"
            className="applock-btn applock-btn-secondary"
            onClick={onSkip}
          >
            <ShieldOff size={20} strokeWidth={2} />
            Skip for Now
          </button>
        </div>
        <p className="applock-hint">
          <Lock size={14} strokeWidth={2} />
          You can enable this later from Settings at any time.
        </p>
      </div>
    </div>
  );
}
